import { useEffect } from "react"
import { useParams } from "react-router-dom";

const LinkRedirect: React.FC = () => {
    const appName = "dropsocials";
    //const appPath = "dropsocials.com";
    const appPath = "dropsocials.com";
    //const appPath = "server02.ogmastage.com";
    const appPackage = "com.dropsocials.Drop";
    let fallback = "https://apps.apple.com/app/id6739772098?mt=8";
    const { userCode } = useParams<{ userCode: string }>();


    function navigateFallback() {
        const now = Date.now();
        setTimeout(() => {
            if (Date.now() - now < 1500) {
                window.location.href = fallback;
            }
        }, 1000);
    }

    useEffect(() => {
        if (/Android/i.test(window.navigator.userAgent)) {
            let intentURL = `intent://${userCode}#Intent;scheme=${appName};package=${appPackage};action=android.intent.action.VIEW;category=android.intent.category.DEFAULT;category=android.intent.category.BROWSABLE;`;
            fallback = "https://play.google.com/store/apps/details?id=com.dropsocials.Drop";
            //if (fallback) {
                intentURL += `S.browser_fallback_url=${encodeURIComponent(
                    fallback
                )}`;
            //}
            intentURL += `;end`;
            window.location.href = intentURL;
            navigateFallback();
            return;
        } else if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
            const deepLink = `${appName}://${appPath}/${userCode}`;
            window.location.href = deepLink;
            navigateFallback();

            return;
        }
         window.location.href = fallback;
    }, []);


    return (
        <main className="main-content">
        <div className="top-cover u-padding-block-end-56">
            <div className="container u-flex-vertical u-cross-center"
                 style={{ maxWidth: "40rem", display: "none" }}>

            </div>
        </div>
    </main>
    )
}

export default LinkRedirect;